/**
 * Shared validation utilities for WineryXplorer
 * These functions ensure consistent validation between frontend and backend
 */
/**
 * Calculate age from a birthday date
 */
export const calculateAge = (birthday) => {
    const today = new Date();
    let age = today.getFullYear() - birthday.getFullYear();
    const monthDiff = today.getMonth() - birthday.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthday.getDate())) {
        age--;
    }
    return age;
};
/**
 * Default minimum drinking age for countries not explicitly listed.
 * 18 is the global mode; used as a safe fallback (incl. the "Other" picker option).
 */
export const DEFAULT_DRINKING_AGE = 18;
/**
 * Minimum legal drinking age by country, keyed by the display names emitted by
 * the onboarding country pickers (see apps/mobile step-birthday + apps/web
 * Onboarding). National-level only — sub-national variation (e.g. Canadian
 * provinces at 18) is intentionally not modeled; Canada is a flat 19.
 */
export const LEGAL_DRINKING_AGE = {
    'united states': 21,
    canada: 19,
    'united kingdom': 18,
    ireland: 18,
    france: 18,
    spain: 18,
    italy: 18,
    portugal: 18,
    germany: 16,
    austria: 16,
    switzerland: 16,
    netherlands: 18,
    belgium: 16,
    australia: 18,
    'new zealand': 18,
    'south africa': 18,
    argentina: 18,
    chile: 18,
    japan: 20,
    mexico: 18,
};
const normalizeCountry = (country) => country.trim().toLowerCase();
/**
 * Get the minimum legal drinking age for a country.
 * Falls back to DEFAULT_DRINKING_AGE for unlisted / unknown countries.
 */
export const getMinimumAge = (country) => LEGAL_DRINKING_AGE[normalizeCountry(country)] ?? DEFAULT_DRINKING_AGE;
/**
 * Validate age requirements based on country.
 * Returns an error message if validation fails, null if valid.
 */
export const validateAge = (birthday, country) => {
    const age = calculateAge(birthday);
    const minimum = getMinimumAge(country);
    if (age < minimum) {
        return `You must be at least ${minimum} years old to use WineryXplorer in ${country.trim()}.`;
    }
    return null;
};
